import script from "./Address.vue?vue&type=script&lang=ts&setup=true"
export * from "./Address.vue?vue&type=script&lang=ts&setup=true"

import "./Address.vue?vue&type=style&index=0&id=dcdbb106&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcdbb106"]])

export default __exports__